import { LuShoppingCart } from "react-icons/lu";
import { AiOutlineInfoCircle } from "react-icons/ai";
import { calculate_total_price } from "./Calculate_price";
import { useWatch } from "react-hook-form";
import { useState } from "react";
import { InfoModal } from "../components/InfoModal";
import { PriceBreakdown } from "./PriceBreakdown";
import { appConfig } from "../config/appConfig";

export const TotalPrice = ({orders, openBasket, onStartOrder}) => {
  // Watch all form values for real-time price updates
  const formValues = useWatch();
  const [showPriceBreakdown, setShowPriceBreakdown] = useState(false);
  const [showTerms, setShowTerms] = useState(false);
  const [acceptedTerms, setAcceptedTerms] = useState(true);

  // Calculate price based on current form values
  const total_price = calculate_total_price(formValues);


  return (
    <>
      <div className="p-4">
        <div className="flex items-start mb-4">
          <div className="flex items-center h-5">
            <input
              type="checkbox"
              id="voorwaarden"
              checked={acceptedTerms}
              onChange={(e) => setAcceptedTerms(e.target.checked)}
              className="w-4 h-4 border border-gray-300 rounded-lg bg-white focus:ring-2 focus:ring-gray-400 transition-all cursor-pointer"
              style={{ accentColor: '#1f2937' }}
            />
          </div>
          <label htmlFor="voorwaarden" className="ms-2.5 text-xs font-medium text-gray-700 cursor-pointer">
            Ik ben akkoord met de{' '}
            <button
              type="button"
              onClick={(e) => {
                e.preventDefault();
                setShowTerms(true);
              }}
              className="text-gray-900 hover:underline font-semibold"
            >
              voorwaarden
            </button>
          </label>
        </div>

        <div className="flex justify-between items-center">
          <div className="flex flex-col">
            <div className="flex items-center gap-2">
              <span className="text-2xl md:text-3xl font-bold text-gray-900">
                € {Number.isFinite(total_price) ? total_price.toLocaleString('nl-BE', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : '0,00'}
              </span>
              <button
                onClick={() => setShowPriceBreakdown(true)}
                className="text-gray-600 hover:text-gray-900 transition-colors p-1.5 hover:bg-gray-100 rounded-lg"
                aria-label="Toon prijsdetails"
                title="Bekijk prijsopbouw"
              >
                <AiOutlineInfoCircle className="text-xl" />
              </button>
            </div>
            <span className="text-gray-600 text-xs font-medium mt-1">Incl. 21% BTW</span>
          </div>
          <div className="flex gap-2.5">
            {/* Shopping basket button - commented out for now
            <button
              onClick={openBasket}
              type="button"
              className="relative inline-flex items-center p-2.5 text-sm font-medium text-center text-gray-700 bg-white/60 rounded-xl hover:bg-white border border-gray-200 hover:shadow-md focus:ring-2 focus:outline-none focus:ring-gray-300 transition-all duration-200"
            >
              <LuShoppingCart className="text-gray-700 font-black text-lg" />
              <span className="sr-only">Winkelwagen</span>
              <div className="absolute inline-flex items-center justify-center w-5 h-5 text-xs font-bold text-white bg-gray-900 border-2 border-white rounded-full -top-2 -end-2 shadow-md">
                {orders.length}
              </div>
            </button>
            */}

            <button
              type="button"
              onClick={onStartOrder}
              disabled={!acceptedTerms}
              className={`text-white font-semibold rounded-xl text-sm px-5 py-2.5 text-center inline-flex items-center transition-all duration-200 shadow-md ${
                acceptedTerms
                  ? 'bg-gray-900 hover:bg-gray-800 focus:ring-2 focus:outline-none focus:ring-gray-400 hover:shadow-lg cursor-pointer'
                  : 'bg-gray-400 cursor-not-allowed'
              }`}
              title={!acceptedTerms ? 'Accepteer eerst de voorwaarden' : ''}
            >
              Bestellen
            </button>
          </div>
        </div>
      </div>

      {/* Price Breakdown Modal */}
      <InfoModal
        isOpen={showPriceBreakdown}
        onClose={() => setShowPriceBreakdown(false)}
        title="Prijsopbouw"
      >
        <PriceBreakdown formValues={formValues} />
      </InfoModal>

      {/* Terms and Conditions Modal */}
      <InfoModal
        isOpen={showTerms}
        onClose={() => setShowTerms(false)}
        title={appConfig.termsAndConditions.title}
      >
        <div
          className="text-gray-700 text-sm leading-relaxed"
          dangerouslySetInnerHTML={{ __html: appConfig.termsAndConditions.content }}
        />
      </InfoModal>
    </>
  );
};
